var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TotemSelect',{staticClass:"select-language",attrs:{"options":_vm.languages,"value":_vm.getSelectedLanguage,"clearable":false,"width":_vm.width,"isLanguageSelector":true,"theme":_vm.theme},on:{"input":_vm.setSelectedLanguage}})}
var staticRenderFns = []

export { render, staticRenderFns }